/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Select_AllInputs */

const en_select_all = /** @type {(inputs: Select_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select All`)
};

const nl_select_all = /** @type {(inputs: Select_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecteer Alles`)
};

/**
* | output |
* | --- |
* | "Select All" |
*
* @param {Select_AllInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const select_all = /** @type {((inputs?: Select_AllInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Select_AllInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_select_all(inputs)
	return en_select_all(inputs)
});